import * as TYPES from '../types';

const initialState = {
    userDetails: {},
};

export function AuthReducer(state = initialState, action) {
    const preState = { ...state };
    const { type, payload } = action;
    switch (type) {
        case TYPES.SIGN_IN_SUCCESS:
            return {
                ...preState,
                userDetails: payload,
            };

        default:
            return state;
    }
}